import React, { ChangeEvent } from 'react'
import uniqueId from 'lodash/uniqueId'
import cn from 'classnames'

import { IRadioButtonUniversalProps } from './interface'
import './styles.scss'

const bc = 'radio-button-universal'

// !!! Do not forget to set type="radio" in case when you using this component in redux-form Field !!!

const RadioButtonUniversal: React.FC<IRadioButtonUniversalProps> = ({
  input,
  disabledComponent,
  enabledComponent,
  className,
  customAction,
}) => {
  const id = uniqueId()
  const checked = input && input.checked
  if (customAction) {
    const handleOnChange = input.onChange
    input.onChange = (e: ChangeEvent<any>) => {
      handleOnChange(e)
      customAction()
    }
  }
  return (
    <div className={cn(bc, { [className]: className })}>
      <label
        htmlFor={id}
        onClick={() => {
          if (checked && customAction) {
            customAction()
          }
        }}
      >
        {checked ? enabledComponent : disabledComponent}
        <input type="radio" id={id} {...input} />
      </label>
    </div>
  )
}

export default RadioButtonUniversal
